/* src/app/shared/contract/contract-item/contract-cgrp-on/contract-cgrp-on.component.scss */
.light-flex-card {
  background-color: #FFF;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  padding: 7px 10px;
  margin-bottom: 20px;
}
.sub-title {
  font: 700 16px FranceTV Brown;
  color: #001A33;
}
.header-item-filters {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
  height: 30px;
  margin-bottom: 15px;
}
.container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 20px;
  margin: 0;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.item {
  background-color: white;
  border-radius: 5px;
  padding: 15px;
}
.item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font: 400 12px FranceTV Brown;
}
.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}
.item-header .title {
  width: 200px;
}
.item-header .date-range {
  width: 120px;
}
.item-header .ca {
  width: 60px;
}
.item-options {
  display: flex;
  align-items: center;
  min-width: 500px;
  max-width: 75%;
  overflow-y: auto;
}
.item-options .option-type-icon {
  height: 16px;
  margin-right: 5px;
}
.option-products {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  gap: 2px;
  margin-right: 20px;
}
.item-actions {
  display: flex;
  align-items: center;
  gap: 25px;
}
.item-actions mat-icon {
  cursor: pointer;
  color: #616161;
  height: 20px;
}
.fade-in-right {
  animation: fadeInRight 0.5s forwards;
}
.fade-out-left {
  animation: fadeOutLeft 0.5s forwards;
}
@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(-100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes fadeOutLeft {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-100%);
  }
}
.mat-expansion-panel-header {
  height: 58px;
  padding: 0 15px 0 10px;
}
.mat-expansion-indicator {
  background-color: red;
}
.mat-expansion-panel-body {
  padding: 0 0 15px !important;
}
/*# sourceMappingURL=contract-cgrp-on.component.css.map */
